class QuickOrderFeed {
  constructor() {
    this.currentCollection = null;
    this.currentPage = 1;
    this.productsPerPage = 12;
    this.allProducts = [];
    this.filteredProducts = [];
    this.cart = {};
    this.updateQueue = {};
    this.updateTimers = {};
    this.productIdToCollection = {}; // Map product_id → collection name
    this.toastTimeout = null;
    this.isUpdating = false; // Flag pour désactiver les boutons pendant les requêtes

    this.init();
    this.createToastContainer();
  }

  async init() {
    this.cacheDOMElements();
    this.bindEvents();
    await this.loadAllCollectionsInfinite();
    this.setupIntersectionObserver();
    // Charger l'état du panier au démarrage
    await this.refreshCart();

    // Debug: Logger la position de la sidebar
    this.debugSidebarPosition();
  }

  debugSidebarPosition() {
    const sidebarRight = document.querySelector('.quick-order-feed__sidebar--right');
    const sidebarLeft = document.querySelector('.quick-order-feed__sidebar--left');
    const wrapper = document.querySelector('.quick-order-feed__wrapper');

    if (!sidebarRight) {
      console.log('❌ Sidebar right not found!');
      return;
    }

    const rectRight = sidebarRight.getBoundingClientRect();
    const styleRight = window.getComputedStyle(sidebarRight);

    console.log('🔍 DEBUG SIDEBAR RIGHT:');
    console.log('  → Position:', styleRight.position);
    console.log('  → Top:', styleRight.top);
    console.log('  → Height:', styleRight.height);
    console.log('  → Align-self:', styleRight.alignSelf);
    console.log('  → BoundingClientRect top:', rectRight.top);
    console.log('  → BoundingClientRect height:', rectRight.height);

    if (sidebarLeft) {
      const rectLeft = sidebarLeft.getBoundingClientRect();
      const styleLeft = window.getComputedStyle(sidebarLeft);
      console.log('\n🔍 DEBUG SIDEBAR LEFT (pour comparaison):');
      console.log('  → Position:', styleLeft.position);
      console.log('  → Top:', styleLeft.top);
      console.log('  → BoundingClientRect top:', rectLeft.top);
    }

    if (wrapper) {
      const rectWrapper = wrapper.getBoundingClientRect();
      console.log('\n🔍 DEBUG WRAPPER:');
      console.log('  → BoundingClientRect top:', rectWrapper.top);
    }

    console.log('\n  → Viewport height:', window.innerHeight);
    console.log('  → Différence (doit être compensée):', rectRight.top, 'px');

    // Vérifier si les styles sont bien appliqués
    const cartHeader = document.querySelector('.quick-order-feed__cart-header');
    if (cartHeader) {
      const cartHeaderRect = cartHeader.getBoundingClientRect();
      const cartHeaderStyle = window.getComputedStyle(cartHeader);
      console.log('\n🔍 DEBUG CART HEADER:');
      console.log('  → Padding:', cartHeaderStyle.padding);
      console.log('  → BoundingClientRect top:', cartHeaderRect.top);
      console.log('  → Distance from sidebar top:', cartHeaderRect.top - rectRight.top);
    }
  }

  cacheDOMElements() {
    this.collectionsNav = document.getElementById('collections-nav');
    this.productsGrid = document.getElementById('products-grid');
    this.cartItemsContainer = document.getElementById('cart-items');
    this.cartCountElement = document.getElementById('cart-count');
    this.cartTotalElement = document.getElementById('cart-total');
    this.collectionTitle = document.getElementById('collection-title');
    this.searchInput = document.getElementById('product-search');
    this.productCardTemplate = document.getElementById('product-card-template');
  }

  createToastContainer() {
    // Créer le conteneur de toast s'il n'existe pas
    if (!document.querySelector('.quick-order-toast')) {
      const toast = document.createElement('div');
      toast.className = 'quick-order-toast';
      toast.innerHTML = `
        <div class="quick-order-toast__icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <polyline points="20 6 9 17 4 12"></polyline>
          </svg>
        </div>
        <span class="quick-order-toast__message"></span>
      `;
      document.body.appendChild(toast);
      this.toast = toast;
    }
  }

  showToast(message) {
    if (!this.toast) return;

    const messageEl = this.toast.querySelector('.quick-order-toast__message');
    messageEl.textContent = message;

    // Afficher le toast
    this.toast.classList.add('show');

    // Cacher après 3 secondes
    if (this.toastTimeout) clearTimeout(this.toastTimeout);
    this.toastTimeout = setTimeout(() => {
      this.toast.classList.remove('show');
    }, 3000);
  }

  pulseCartCount() {
    if (!this.cartCountElement) return;

    this.cartCountElement.classList.remove('pulse');
    // Force reflow pour redémarrer l'animation
    void this.cartCountElement.offsetWidth;
    this.cartCountElement.classList.add('pulse');

    // Retirer la classe après l'animation
    setTimeout(() => {
      this.cartCountElement.classList.remove('pulse');
    }, 500);
  }

  updateHeaderCartCount(itemCount) {
    console.log('🔄 Updating header cart count to:', itemCount);

    // Méthode 1: Chercher l'élément cart-count dans le header
    const headerCartCount = document.querySelector('.cart-count, cart-count');
    if (headerCartCount) {
      headerCartCount.textContent = itemCount;

      // Afficher/cacher selon la quantité
      if (itemCount > 0) {
        headerCartCount.removeAttribute('hidden');
        headerCartCount.setAttribute('aria-label', `${itemCount} élément${itemCount > 1 ? 's' : ''}`);
      } else {
        headerCartCount.setAttribute('hidden', '');
      }

      console.log('  → Header cart count updated!');
    }

    // Méthode 2: Déclencher un événement Shopify standard pour la compatibilité
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: { cart: { item_count: itemCount } }
      })
    );
  }

  bindEvents() {
    // Collection navigation - scroll to section
    if (this.collectionsNav) {
      this.collectionsNav.addEventListener('click', (e) => {
        const collectionButton = e.target.closest('.quick-order-feed__collection-item');
        if (collectionButton) {
          const handle = collectionButton.dataset.collectionHandle;
          const section = document.getElementById(`collection-${handle}`);
          if (section) {
            // Calculer l'offset pour éviter que la section soit cachée par le header
            const headerHeight = document.querySelector('.section-header')?.offsetHeight || 100;
            const sidebarHeight = window.innerWidth <= 1024
              ? (document.querySelector('.quick-order-feed__sidebar--left')?.offsetHeight || 80)
              : 0;
            const offset = headerHeight + sidebarHeight + 20;

            const sectionTop = section.getBoundingClientRect().top + window.pageYOffset - offset;
            window.scrollTo({ top: sectionTop, behavior: 'smooth' });
          }
        }
      });
    }

    // Product search avec debounce
    if (this.searchInput) {
      let searchTimeout;
      this.searchInput.addEventListener('input', (e) => {
        const searchContainer = e.target.closest('.quick-order-feed__search');

        // Toggle la classe has-value pour afficher/cacher le bouton X
        if (e.target.value) {
          searchContainer.classList.add('has-value');
        } else {
          searchContainer.classList.remove('has-value');
        }

        // Debounce : attendre 300ms avant de lancer la recherche
        clearTimeout(searchTimeout);
        searchTimeout = setTimeout(() => {
          this.filterProducts(e.target.value);
        }, 300);
      });

      // Raccourci Esc pour effacer la recherche
      this.searchInput.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          this.clearSearch();
        }
      });
    }

    // Bouton X pour effacer la recherche
    const clearSearchBtn = document.getElementById('search-clear');
    if (clearSearchBtn) {
      clearSearchBtn.addEventListener('click', () => {
        this.clearSearch();
      });
    }

    // Product actions
    this.productsGrid.addEventListener('click', (e) => {
      const qtyBtn = e.target.closest('.quick-order-feed__qty-btn');
      if (qtyBtn) {
        this.handleQuantityChange(qtyBtn);
        return;
      }

      // Clic sur tout le conteneur d'actions (pas sur un bouton spécifique)
      // Si quantité = 0, ajouter 1 au panier
      const actionsContainer = e.target.closest('.quick-order-feed__product-actions');
      if (actionsContainer) {
        const input = actionsContainer.querySelector('.quick-order-feed__qty-input');
        const currentQty = parseInt(input?.value || '0');

        if (currentQty === 0) {
          const plusBtn = actionsContainer.querySelector('.quick-order-feed__qty-btn--plus');
          if (plusBtn && !plusBtn.disabled) {
            this.handleQuantityChange(plusBtn);
          }
        }
      }
    });

    this.productsGrid.addEventListener('change', (e) => {
      if (e.target.classList.contains('quick-order-feed__qty-input')) {
        this.handleQuantityInputChange(e.target);
      }
    });

    // Input event pour mise à jour en temps réel quand on tape
    this.productsGrid.addEventListener('input', (e) => {
      if (e.target.classList.contains('quick-order-feed__qty-input')) {
        // Debounce pour éviter trop de requêtes
        const input = e.target;
        const variantId = input.dataset.variantId;

        // Clear existing timer
        if (this.inputTimers && this.inputTimers[variantId]) {
          clearTimeout(this.inputTimers[variantId]);
        }

        // Init timers object if needed
        if (!this.inputTimers) this.inputTimers = {};

        // Set new timer (500ms debounce)
        this.inputTimers[variantId] = setTimeout(() => {
          this.handleQuantityInputChange(input);
        }, 500);
      }
    });

    // Cart actions
    if (this.cartItemsContainer) {
      this.cartItemsContainer.addEventListener('click', (e) => {
        const qtyBtn = e.target.closest('.quick-order-cart-item__qty-btn');
        const removeBtn = e.target.closest('.quick-order-cart-item__remove');

        if (qtyBtn) {
          this.updateCartItem(qtyBtn.dataset.itemId, qtyBtn.dataset.action);
        }

        if (removeBtn) {
          this.removeCartItem(removeBtn.dataset.itemId);
        }
      });
    }

    // Clear cart button
    const clearCartBtn = document.getElementById('clear-cart');
    if (clearCartBtn) {
      clearCartBtn.addEventListener('click', () => {
        if (confirm('Êtes-vous sûr de vouloir vider le panier ?')) {
          this.clearCart();
        }
      });
    }
  }

  async loadFirstCollection() {
    const firstCollection = this.collectionsNav?.querySelector('.quick-order-feed__collection-item');
    if (firstCollection) {
      await this.loadCollection(firstCollection.dataset.collectionHandle);
    }
  }

  async loadCollection(handle) {
    console.log('📦 Loading collection:', handle);
    try {
      this.showLoading();
      this.currentCollection = handle;
      this.currentPage = 1;

      // Update active collection
      document.querySelectorAll('.quick-order-feed__collection-item').forEach(btn => {
        btn.classList.toggle('active', btn.dataset.collectionHandle === handle);
      });

      // Fetch collection products
      const response = await fetch(`/collections/${handle}/products.json?limit=250`);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (!data.products || data.products.length === 0) {
        this.showError('Aucun produit trouvé dans cette collection');
        this.allProducts = [];
        this.filteredProducts = [];
        return;
      }

      this.allProducts = data.products;
      this.filteredProducts = [...this.allProducts];
      console.log('  → Loaded', this.allProducts.length, 'products');

      // Update collection title
      const activeCollection = document.querySelector('.quick-order-feed__collection-item.active');
      if (this.collectionTitle && activeCollection) {
        const titleSpan = activeCollection.querySelector('span');
        if (titleSpan) {
          this.collectionTitle.textContent = titleSpan.textContent;
        }
      }

      this.renderProducts();
    } catch (error) {
      console.error('Error loading collection:', error);
      console.error('Collection handle:', handle);
      console.error('Error details:', error.message);
      this.showError('Erreur lors du chargement des produits. Vérifiez la console pour plus de détails.');
    }
  }

  clearSearch() {
    if (this.searchInput) {
      this.searchInput.value = '';
      const searchContainer = this.searchInput.closest('.quick-order-feed__search');
      if (searchContainer) {
        searchContainer.classList.remove('has-value');
      }
    }

    // Afficher toutes les sections
    document.querySelectorAll('.quick-order-feed__collection-section').forEach(section => {
      section.style.display = 'block';
      section.querySelectorAll('.quick-order-feed__product-card').forEach(card => {
        card.style.display = 'block';
      });
    });

    // Cacher le message vide
    const emptyMessage = document.querySelector('.quick-order-feed__search-empty');
    if (emptyMessage) {
      emptyMessage.style.display = 'none';
    }

    // Effacer le nombre de résultats
    const resultsEl = document.getElementById('search-results');
    if (resultsEl) {
      resultsEl.textContent = '';
    }
  }

  filterProducts(searchTerm) {
    const term = searchTerm.toLowerCase().trim();

    console.log('🔍 Searching for:', term);

    const resultsEl = document.getElementById('search-results');

    if (!term) {
      // Pas de recherche : afficher toutes les sections
      console.log('  → No search term, showing all sections');
      document.querySelectorAll('.quick-order-feed__collection-section').forEach(section => {
        section.style.display = 'block';
        section.querySelectorAll('.quick-order-feed__product-card').forEach(card => {
          card.style.display = 'block';
        });
      });

      if (resultsEl) resultsEl.textContent = '';
      return;
    }

    // Recherche : filtrer les produits
    const filteredProducts = this.allProducts.filter(product =>
      product.title.toLowerCase().includes(term) ||
      product.vendor.toLowerCase().includes(term) ||
      (product.tags && product.tags.some(tag => tag.toLowerCase().includes(term)))
    );

    console.log(`  → Found ${filteredProducts.length} products`);

    // Afficher le nombre de résultats
    if (resultsEl) {
      resultsEl.textContent = filteredProducts.length > 0
        ? `${filteredProducts.length} produit${filteredProducts.length > 1 ? 's' : ''} trouvé${filteredProducts.length > 1 ? 's' : ''}`
        : '';
    }

    if (filteredProducts.length === 0) {
      // Cacher toutes les sections et afficher un message
      document.querySelectorAll('.quick-order-feed__collection-section').forEach(section => {
        section.style.display = 'none';
      });

      // Ajouter un message si nécessaire
      let emptyMessage = document.querySelector('.quick-order-feed__search-empty');
      if (!emptyMessage) {
        emptyMessage = document.createElement('div');
        emptyMessage.className = 'quick-order-feed__search-empty';
        emptyMessage.innerHTML = '<p>Aucun produit trouvé</p>';
        this.productsGrid.appendChild(emptyMessage);
      }
      emptyMessage.style.display = 'block';
      return;
    }

    // Cacher le message vide si présent
    const emptyMessage = document.querySelector('.quick-order-feed__search-empty');
    if (emptyMessage) {
      emptyMessage.style.display = 'none';
    }

    // Grouper les résultats par collection
    const productsByCollection = {};
    filteredProducts.forEach(product => {
      const collection = product._collectionName || 'Autres';
      if (!productsByCollection[collection]) {
        productsByCollection[collection] = [];
      }
      productsByCollection[collection].push(product);
    });

    // Afficher/cacher les sections selon les résultats
    document.querySelectorAll('.quick-order-feed__collection-section').forEach(section => {
      const collectionName = section.querySelector('.quick-order-feed__collection-section-title')?.textContent;

      if (productsByCollection[collectionName]) {
        // Cette collection a des résultats : afficher uniquement les produits correspondants
        section.style.display = 'block';
        const productCards = section.querySelectorAll('.quick-order-feed__product-card');
        const matchingProductIds = new Set(productsByCollection[collectionName].map(p => p.id));

        productCards.forEach(card => {
          const productId = parseInt(card.dataset.productId);
          card.style.display = matchingProductIds.has(productId) ? 'block' : 'none';
        });
      } else {
        // Aucun résultat pour cette collection
        section.style.display = 'none';
      }
    });
  }

  renderProducts() {
    // Cette fonction n'est plus utilisée avec le système infinite scroll
    // La recherche gère maintenant l'affichage/masquage directement
  }

  createProductCard(product) {
    console.log('🎨 Creating product card:', product.title);
    const card = document.createElement('div');
    card.className = 'quick-order-feed__product-card';
    card.dataset.productId = product.id;

    const variant = product.variants[0];
    // L'API products.json retourne le prix en euros (string), pas en centimes
    // On multiplie par 100 pour convertir en centimes pour formatMoney
    const priceInCents = parseFloat(variant.price) * 100;
    const image = product.images && product.images.length > 0 ? product.images[0] : null;
    const imageSrc = image ? (typeof image === 'string' ? image : image.src) : '';
    // Demander une image plus grande pour une meilleure qualité (800px pour les écrans haute résolution)
    const imageUrl = imageSrc ? (imageSrc.includes('?') ? `${imageSrc}&width=800` : `${imageSrc}?width=800`) : '';

    // Récupérer la 2ème image pour le hover
    const image2 = product.images && product.images.length > 1 ? product.images[1] : null;
    const imageSrc2 = image2 ? (typeof image2 === 'string' ? image2 : image2.src) : '';
    const imageUrl2 = imageSrc2 ? (imageSrc2.includes('?') ? `${imageSrc2}&width=800` : `${imageSrc2}?width=800`) : '';

    const productUrl = product.handle ? `/products/${product.handle}` : '#';
    const price = this.formatMoney(priceInCents);
    const available = variant.available;

    console.log('  → Variant ID:', variant.id, '| Available:', available);

    console.log('  → Creating HTML with collapsed state');

    card.innerHTML = `
      <div class="quick-order-feed__product-image">
        <a href="${productUrl}" class="quick-order-feed__product-link">
          <img src="${imageUrl}" alt="${product.title}" loading="lazy" class="quick-order-feed__product-img-primary">
          ${imageUrl2 ? `<img src="${imageUrl2}" alt="${product.title}" loading="lazy" class="quick-order-feed__product-img-secondary">` : ''}
        </a>
      </div>
      <div class="quick-order-feed__product-info">
        <div class="quick-order-feed__product-header">
          ${available ?
            '<span class="quick-order-feed__product-stock" aria-label="Produit en stock">En stock</span>' :
            '<span class="quick-order-feed__product-stock quick-order-feed__product-stock--out" aria-label="Produit en rupture de stock">Rupture</span>'
          }
        </div>
        <h3 class="quick-order-feed__product-title"><a href="${productUrl}" class="quick-order-feed__product-title-link">${product.title}</a></h3>
        <div class="quick-order-feed__product-footer">
          <div class="quick-order-feed__product-price-section">
            ${window.customerLoggedIn && !window.customerIsPending ?
              `<div class="quick-order-feed__product-price-label">Prix</div>
              <div class="quick-order-feed__product-price">${price}</div>` :
              window.customerIsPending ?
              `<div style="text-align: center; padding: 0.75rem; background: #fff7ed; border: 1px solid #fed7aa; border-radius: 6px;">
                <p style="color: #92400e; font-weight: 600; font-size: 1.31rem; margin: 0;">⏳ En attente</p>
              </div>` :
              `<a href="/account/login" class="btn btn--secondary btn--small" style="display: inline-block; padding: 0.6rem 1.2rem; font-size: 1.125rem;"><span class="btn__text">Se connecter</span></a>`
            }
          </div>
          ${window.customerLoggedIn && !window.customerIsPending ? `
            <div class="quick-order-feed__product-actions collapsed" data-variant-id="${variant.id}">
              <button type="button" class="quick-order-feed__qty-btn quick-order-feed__qty-btn--minus"
                      data-action="decrease" data-variant-id="${variant.id}" ${!available ? 'disabled' : ''}>
                <svg width="16" height="16" viewBox="0 0 16 16"><path d="M2 8h12" stroke="currentColor" stroke-width="2.5" fill="none" stroke-linecap="round"/></svg>
              </button>
              <input type="number" class="quick-order-feed__qty-input" value="0" min="0" max="999"
                     data-variant-id="${variant.id}" ${!available ? 'disabled' : ''}>
              <button type="button" class="quick-order-feed__qty-btn quick-order-feed__qty-btn--plus"
                      data-action="increase" data-variant-id="${variant.id}" ${!available ? 'disabled' : ''}>
                <svg width="16" height="16" viewBox="0 0 16 16"><path d="M2 8h12M8 2v12" stroke="currentColor" stroke-width="2.5" fill="none" stroke-linecap="round"/></svg>
              </button>
            </div>
          ` : ''}
        </div>
      </div>
    `;

    // Initialiser l'affichage des boutons (par défaut quantité = 0)
    setTimeout(() => {
      const actionsContainer = card.querySelector('.quick-order-feed__product-actions');
      this.updateActionDisplay(actionsContainer, 0);
    }, 0);

    return card;
  }

  async handleQuantityChange(button) {
    const action = button.dataset.action;
    const variantId = button.dataset.variantId;
    console.log('🖱️ Button clicked:', action, '| Variant:', variantId);

    const productCard = button.closest('.quick-order-feed__product-card');
    const actionsContainer = productCard.querySelector('.quick-order-feed__product-actions');
    const input = productCard.querySelector('.quick-order-feed__qty-input');

    let currentQty = parseInt(input.value) || 0;
    console.log('  → Current quantity:', currentQty);

    if (action === 'increase') {
      currentQty++;
    } else if (action === 'decrease' && currentQty > 0) {
      currentQty--;
    } else if (action === 'delete') {
      currentQty = 0;
    }

    input.value = currentQty;
    console.log('  → New quantity:', currentQty);

    // Mettre à jour l'affichage selon la quantité
    this.updateActionDisplay(actionsContainer, currentQty);

    // Debounce : attendre 300ms avant d'envoyer la requête
    this.debouncedUpdateCart(variantId, currentQty);
  }

  updateActionDisplay(actionsContainer, quantity) {
    const minusBtn = actionsContainer.querySelector('.quick-order-feed__qty-btn--minus');
    const input = actionsContainer.querySelector('.quick-order-feed__qty-input');
    const plusBtn = actionsContainer.querySelector('.quick-order-feed__qty-btn--plus');

    if (quantity === 0) {
      // Quantité = 0 : cacher input et bouton moins
      input.style.setProperty('display', 'none', 'important');
      minusBtn.style.setProperty('display', 'none', 'important');
    } else if (quantity === 1) {
      // Quantité = 1 : montrer input et transformer le bouton en poubelle
      input.style.setProperty('display', 'block', 'important');
      minusBtn.style.setProperty('display', 'flex', 'important');
      minusBtn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="display: block; width: 16px; height: 16px; min-width: 16px; min-height: 16px;"><path d="M3 6h18"/><path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"/><path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"/><line x1="10" y1="11" x2="10" y2="17"/><line x1="14" y1="11" x2="14" y2="17"/></svg>';
      minusBtn.dataset.action = 'decrease'; // Garder decrease, la fonction va mettre à 0
    } else {
      // Quantité > 1 : montrer input et bouton moins normal
      input.style.setProperty('display', 'block', 'important');
      minusBtn.style.setProperty('display', 'flex', 'important');
      minusBtn.innerHTML = '<svg width="16" height="16" viewBox="0 0 16 16"><path d="M2 8h12" stroke="currentColor" stroke-width="2.5" fill="none" stroke-linecap="round"/></svg>';
      minusBtn.dataset.action = 'decrease';
    }
  }

  debouncedUpdateCart(variantId, quantity) {
    // Annuler le timer précédent pour ce variant
    if (this.updateTimers[variantId]) {
      clearTimeout(this.updateTimers[variantId]);
    }

    // Stocker la nouvelle quantité
    this.updateQueue[variantId] = quantity;

    // Créer un nouveau timer
    this.updateTimers[variantId] = setTimeout(async () => {
      const qtyToUpdate = this.updateQueue[variantId];
      delete this.updateQueue[variantId];
      delete this.updateTimers[variantId];

      console.log('⏱️ Debounce completed, sending update for variant', variantId, '→', qtyToUpdate);
      await this.updateCart(variantId, qtyToUpdate);
    }, 300);
  }

  async handleQuantityInputChange(input) {
    const variantId = input.dataset.variantId;
    const quantity = Math.max(0, parseInt(input.value) || 0);
    input.value = quantity;
    await this.updateCart(variantId, quantity);
  }

  async updateCart(variantId, quantity) {
    console.log('🛒 Updating cart:', { variantId, quantity });

    // Désactiver les boutons pendant la requête
    this.isUpdating = true;
    this.setButtonsDisabled(variantId, true);

    try {
      // Utiliser /cart/update.js pour SET la quantité directement
      const formData = {
        updates: {
          [variantId]: quantity
        }
      };

      console.log('  → Updating cart via /cart/update.js:', formData);

      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      });

      console.log('  → Response status:', response.status);

      if (!response.ok) {
        const errorText = await response.text();
        console.error('  ❌ Cart update failed:', errorText);
        throw new Error('Cart update failed: ' + errorText);
      }

      const cart = await response.json();
      console.log('  ✅ Cart updated:', { item_count: cart.item_count, items: cart.items.length });

      // Afficher le toast et l'animation pulse
      if (quantity > 0) {
        this.showToast('Produit ajouté au panier');
        this.pulseCartCount();
      }

      this.refreshCart(cart);
    } catch (error) {
      console.error('❌ Error updating cart:', error);
      this.showToast('Erreur lors de la mise à jour');
    } finally {
      // Réactiver les boutons
      this.isUpdating = false;
      this.setButtonsDisabled(variantId, false);
    }
  }

  setButtonsDisabled(variantId, disabled) {
    const actionsContainer = document.querySelector(`.quick-order-feed__product-actions[data-variant-id="${variantId}"]`);
    if (!actionsContainer) return;

    const buttons = actionsContainer.querySelectorAll('button');
    buttons.forEach(btn => {
      btn.disabled = disabled;
      if (disabled) {
        btn.style.opacity = '0.5';
        btn.style.cursor = 'not-allowed';
      } else {
        btn.style.opacity = '';
        btn.style.cursor = '';
      }
    });
  }

  async updateCartItem(itemKey, action) {
    try {
      const item = this.getCartItemByKey(itemKey);
      if (!item) return;

      let newQuantity = item.quantity;
      if (action === 'increase') {
        newQuantity++;
      } else if (action === 'decrease') {
        newQuantity = Math.max(0, newQuantity - 1);
      }

      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: itemKey,
          quantity: newQuantity
        })
      });

      if (!response.ok) throw new Error('Cart update failed');

      const cart = await response.json();
      this.refreshCart(cart);
    } catch (error) {
      console.error('Error updating cart item:', error);
    }
  }

  async removeCartItem(itemKey) {
    // Ajouter l'animation avant de supprimer
    const cartItem = document.querySelector(`.quick-order-cart-item[data-cart-item-id="${itemKey}"]`);
    if (cartItem) {
      cartItem.classList.add('removing');
    }

    // Attendre la fin de l'animation avant de supprimer
    await new Promise(resolve => setTimeout(resolve, 300));

    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: itemKey,
          quantity: 0
        })
      });

      if (!response.ok) throw new Error('Cart update failed');

      const cart = await response.json();
      this.showToast('Produit retiré du panier');
      this.refreshCart(cart);
    } catch (error) {
      console.error('Error removing cart item:', error);
      this.showToast('Erreur lors de la suppression');
      // Retirer la classe en cas d'erreur
      if (cartItem) {
        cartItem.classList.remove('removing');
      }
    }
  }

  async clearCart() {
    try {
      const response = await fetch('/cart/clear.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        }
      });

      if (!response.ok) throw new Error('Cart clear failed');

      const cart = await response.json();
      this.showToast('Panier vidé');
      this.refreshCart(cart);

      // Réinitialiser toutes les quantités dans la grille
      document.querySelectorAll('.quick-order-feed__qty-input').forEach(input => {
        input.value = 0;
        const actionsContainer = input.closest('.quick-order-feed__product-actions');
        if (actionsContainer) {
          this.updateActionDisplay(actionsContainer, 0);
        }
      });
    } catch (error) {
      console.error('Error clearing cart:', error);
      this.showToast('Erreur lors du vidage du panier');
    }
  }

  async refreshCart(cartData) {
    console.log('🔄 Refreshing cart display...');
    if (!cartData) {
      const response = await fetch('/cart.js');
      cartData = await response.json();
    }

    this.cart = cartData;
    console.log('  → Cart data:', { item_count: cartData.item_count, items: cartData.items });

    // Update cart count dans notre sidebar
    if (this.cartCountElement) {
      this.cartCountElement.textContent = cartData.item_count;
      console.log('  → Updated cart count to:', cartData.item_count);
    }

    // Mettre à jour le compteur du header Shopify
    this.updateHeaderCartCount(cartData.item_count);

    // Update cart total
    if (this.cartTotalElement) {
      this.cartTotalElement.textContent = this.formatMoney(cartData.total_price);
    }

    // Update minimum order warning (400€ = 40000 centimes)
    const minimumOrderAmount = 40000;
    const cartTotal = cartData.total_price;
    const remainingAmount = minimumOrderAmount - cartTotal;
    const canCheckout = cartTotal >= minimumOrderAmount;

    const warningEl = document.getElementById('quick-order-minimum-warning');
    const remainingEl = document.getElementById('quick-order-remaining-amount');
    const checkoutBtn = document.getElementById('quick-order-checkout-btn');

    if (warningEl) {
      warningEl.style.display = canCheckout ? 'none' : 'block';
    }
    if (remainingEl && !canCheckout) {
      remainingEl.textContent = this.formatMoney(remainingAmount).replace('€', '').trim();
    }
    if (checkoutBtn) {
      if (canCheckout) {
        checkoutBtn.disabled = false;
        checkoutBtn.style.opacity = '1';
        checkoutBtn.style.cursor = 'pointer';
        checkoutBtn.type = 'submit';
        checkoutBtn.name = 'checkout';
      } else {
        checkoutBtn.disabled = true;
        checkoutBtn.style.opacity = '0.5';
        checkoutBtn.style.cursor = 'not-allowed';
        checkoutBtn.type = 'button';
        checkoutBtn.removeAttribute('name');
      }
    }

    // Update cart items
    if (this.cartItemsContainer) {
      if (cartData.items.length === 0) {
        this.cartItemsContainer.innerHTML = '<p class="quick-order-feed__cart-empty">Votre panier est vide</p>';
      } else {
        this.cartItemsContainer.innerHTML = this.createGroupedCartHTML(cartData.items);
      }
    }

    // Update product quantities in grid
    console.log('  → Updating product quantities in grid...');
    this.updateProductQuantities(cartData.items);
  }

  updateProductQuantities(cartItems) {
    const variantQuantities = {};
    cartItems.forEach(item => {
      variantQuantities[item.variant_id] = item.quantity;
      console.log('    → Cart item:', item.variant_id, '=', item.quantity);
    });

    console.log('  → Syncing quantities with product cards...');
    document.querySelectorAll('.quick-order-feed__product-actions').forEach(actionsContainer => {
      const variantId = actionsContainer.dataset.variantId;
      const input = actionsContainer.querySelector('.quick-order-feed__qty-input');
      const quantity = variantQuantities[variantId] || 0;

      if (input) {
        input.value = quantity;
        console.log('    → Set variant', variantId, 'to quantity', quantity);
        // Mettre à jour l'affichage selon la quantité
        this.updateActionDisplay(actionsContainer, quantity);
      }

      // Mettre à jour les classes selon la quantité
      this.updateActionClasses(actionsContainer, quantity);
    });
  }

  updateActionClasses(actionsContainer, quantity) {
    const badge = actionsContainer.querySelector('.quick-order-feed__qty-badge');

    if (quantity > 0) {
      console.log('  → Setting has-quantity state');
      actionsContainer.classList.remove('collapsed', 'expanded');
      actionsContainer.classList.add('has-quantity');
      if (badge) {
        badge.textContent = quantity;
        badge.style.display = 'flex';
      }
    } else {
      console.log('  → Setting collapsed state');
      actionsContainer.classList.remove('has-quantity', 'expanded');
      actionsContainer.classList.add('collapsed');
      if (badge) {
        badge.style.display = 'none';
      }
    }
  }

  createGroupedCartHTML(items) {
    console.log('📂 Grouping cart items by collection...');

    // Grouper les items par collection (en utilisant notre map)
    const groupedItems = {};
    items.forEach(item => {
      const productId = item.product_id;
      const collection = this.productIdToCollection[productId] || 'Autres';

      if (!groupedItems[collection]) {
        groupedItems[collection] = [];
      }
      groupedItems[collection].push(item);
      console.log(`  → Item "${item.product_title}" (ID: ${productId}) → Collection "${collection}"`);
    });

    console.log('  → Collections found:', Object.keys(groupedItems));

    // Générer le HTML avec séparateurs
    let html = '';
    const collections = Object.keys(groupedItems);

    collections.forEach((collection, index) => {
      // Ajouter le séparateur de collection
      html += `
        <div class="quick-order-cart-category">
          <div class="quick-order-cart-category__label">${collection}</div>
        </div>
      `;

      // Ajouter les items de cette collection
      groupedItems[collection].forEach(item => {
        html += this.createCartItemHTML(item);
      });
    });

    return html;
  }

  createCartItemHTML(item) {
    console.log('  → Creating cart item HTML for:', item.product_title);
    console.log('    → Full item data:', {
      price: item.price,
      final_price: item.final_price,
      line_price: item.line_price,
      final_line_price: item.final_line_price,
      original_price: item.original_price,
      original_line_price: item.original_line_price
    });

    // Image de meilleure qualité pour le panier (200px au lieu de 120px)
    const imageUrl = item.image ? (item.image.includes('?') ? `${item.image}&width=200` : `${item.image}?width=200`) : '';

    // Prix unitaire et prix total
    const unitPrice = item.final_price || item.price || item.original_price;
    const linePrice = item.final_line_price || item.line_price || item.original_line_price || (unitPrice * item.quantity);
    const formattedUnitPrice = this.formatMoney(unitPrice);
    const formattedTotalPrice = this.formatMoney(linePrice);

    console.log('    → Unit price:', unitPrice, '→ Total price:', linePrice);

    return `
      <div class="quick-order-cart-item" data-cart-item-id="${item.key}">
        <div class="quick-order-cart-item__image">
          <img src="${imageUrl}" alt="${item.title || item.product_title}" width="80" height="80" loading="lazy">
        </div>
        <div class="quick-order-cart-item__details">
          <a href="${item.url}" class="quick-order-cart-item__title">${item.product_title}</a>
          ${item.variant_title && item.variant_title !== 'Default Title' && item.variant_title !== 'null' ? `<div class="quick-order-cart-item__variant">${item.variant_title}</div>` : ''}
          <div class="quick-order-cart-item__pricing">
            <span class="quick-order-cart-item__unit-price">${formattedUnitPrice} × ${item.quantity}</span>
            <span class="quick-order-cart-item__total-price">${formattedTotalPrice}</span>
          </div>
        </div>

        <button type="button" class="quick-order-cart-item__remove" data-action="remove" data-item-id="${item.key}">
          <svg width="14" height="14" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="none" stroke="#ef4444" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="display: block; width: 14px; height: 14px; min-width: 14px; min-height: 14px;">
            <path d="M3 6h18"/>
            <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"/>
            <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"/>
            <line x1="10" y1="11" x2="10" y2="17"/>
            <line x1="14" y1="11" x2="14" y2="17"/>
          </svg>
        </button>

        <div class="quick-order-cart-item__quantity">
          <button type="button" class="quick-order-cart-item__qty-btn" data-action="decrease" data-item-id="${item.key}">
            <svg width="14" height="14" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" style="display: block; width: 14px; height: 14px; min-width: 14px; min-height: 14px;">
              <path d="M4 9h10" stroke="#4b5563" stroke-width="2.5" fill="none" stroke-linecap="round"/>
            </svg>
          </button>
          <span class="quick-order-cart-item__qty">${item.quantity}</span>
          <button type="button" class="quick-order-cart-item__qty-btn" data-action="increase" data-item-id="${item.key}">
            <svg width="14" height="14" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" style="display: block; width: 14px; height: 14px; min-width: 14px; min-height: 14px;">
              <path d="M9 4v10M4 9h10" stroke="white" stroke-width="2.5" fill="none" stroke-linecap="round"/>
            </svg>
          </button>
        </div>
      </div>
    `;
  }

  getCartItemByKey(key) {
    return this.cart.items?.find(item => item.key === key);
  }

  formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, window.theme?.moneyFormat || '{{amount}} €');
    }
    const amount = cents / 100;
    return new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: 'EUR'
    }).format(amount);
  }

  async loadAllCollectionsInfinite() {
    console.log('🔄 Loading all collections for infinite scroll...');
    const collectionButtons = Array.from(document.querySelectorAll('.quick-order-feed__collection-item'));

    if (!collectionButtons.length) {
      console.warn('No collections found');
      return;
    }

    this.productsGrid.innerHTML = ''; // Clear grid
    this.allProducts = []; // Réinitialiser la liste de tous les produits

    for (const button of collectionButtons) {
      const handle = button.dataset.collectionHandle;
      const collectionName = button.querySelector('span:first-of-type')?.textContent || handle;

      console.log(`  → Loading collection: ${collectionName}`);

      try {
        const response = await fetch(`/collections/${handle}/products.json?limit=250`);

        if (!response.ok) continue;

        const data = await response.json();

        if (!data.products || data.products.length === 0) continue;

        // Stocker la collection pour chaque produit ET ajouter à allProducts
        data.products.forEach(product => {
          this.productIdToCollection[product.id] = collectionName;
          // Ajouter le nom de la collection au produit pour la recherche
          product._collectionName = collectionName;
          this.allProducts.push(product);
          console.log(`    📌 Product ${product.id} → Collection "${collectionName}"`);
        });

        // Créer une section pour cette collection
        const section = document.createElement('div');
        section.className = 'quick-order-feed__collection-section';
        section.id = `collection-${handle}`;
        section.dataset.collectionHandle = handle;

        // Titre de la section
        const sectionTitle = document.createElement('h2');
        sectionTitle.className = 'quick-order-feed__collection-section-title';
        sectionTitle.textContent = collectionName;
        section.appendChild(sectionTitle);

        // Grid de produits
        const productsContainer = document.createElement('div');
        productsContainer.className = 'quick-order-feed__products';

        data.products.forEach(product => {
          const card = this.createProductCard(product);
          productsContainer.appendChild(card);
        });

        section.appendChild(productsContainer);
        this.productsGrid.appendChild(section);

        console.log(`    ✓ Loaded ${data.products.length} products`);
      } catch (error) {
        console.error(`Error loading collection ${handle}:`, error);
      }
    }

    console.log(`📦 Total products loaded: ${this.allProducts.length}`);

    // Mettre à jour les quantités du panier sur toutes les cartes
    await this.refreshCart();
  }

  setupIntersectionObserver() {
    console.log('👁️ Setting up Intersection Observer...');

    const options = {
      root: null,
      rootMargin: '-20% 0px -60% 0px',
      threshold: 0
    };

    this.collectionObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const handle = entry.target.dataset.collectionHandle;
          this.updateActiveCollection(handle);
        }
      });
    }, options);

    // Observer toutes les sections
    const sections = document.querySelectorAll('.quick-order-feed__collection-section');
    sections.forEach(section => {
      this.collectionObserver.observe(section);
    });

    // Activer manuellement la première section au chargement
    if (sections.length > 0) {
      const firstHandle = sections[0].dataset.collectionHandle;
      this.updateActiveCollection(firstHandle);
    }
  }

  updateActiveCollection(handle) {
    console.log('📌 Active collection:', handle);

    // Mettre à jour la classe active dans la sidebar
    document.querySelectorAll('.quick-order-feed__collection-item').forEach(btn => {
      btn.classList.toggle('active', btn.dataset.collectionHandle === handle);
    });

    // Faire défiler SEULEMENT la sidebar (pas la page) pour montrer l'élément actif
    const activeButton = document.querySelector(`.quick-order-feed__collection-item[data-collection-handle="${handle}"]`);
    const sidebar = document.querySelector('.quick-order-feed__sidebar--left .quick-order-feed__collections');

    if (activeButton && sidebar) {
      // Sur mobile, scroll horizontal dans la sidebar seulement
      const isMobile = window.innerWidth <= 1024;
      if (isMobile) {
        // Calculer la position pour centrer le bouton dans la sidebar
        const buttonRect = activeButton.getBoundingClientRect();
        const sidebarRect = sidebar.getBoundingClientRect();
        const scrollLeft = activeButton.offsetLeft - (sidebarRect.width / 2) + (buttonRect.width / 2);
        sidebar.scrollTo({ left: scrollLeft, behavior: 'smooth' });
      } else {
        // Sur desktop, scroll vertical dans la sidebar
        activeButton.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }
  }

  showLoading() {
    this.productsGrid.innerHTML = `
      <div class="quick-order-feed__loading">
        <div class="spinner"></div>
        <p>Chargement des produits...</p>
      </div>
    `;
  }

  showError(message) {
    this.productsGrid.innerHTML = `
      <div class="quick-order-feed__error">
        <p>${message}</p>
      </div>
    `;
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new QuickOrderFeed();
  });
} else {
  new QuickOrderFeed();
}
